<template>
  <Grid gap="var(--r-space-lg)" align-content="start" class="renewal-table q-pa-lg bg-white-1 shadow3 border-radius-sm">
    <slot name="header"></slot>

    <GridTable :columns="columns" :rows="rows" mode="ag-grid" style="--row-h: 51px; --rows-max-h: 100%">
      <template #row="{row}">
        <GridTableCell :class="{ 'text-body-3': row.bold }">{{ row.col1 }}</GridTableCell>
        <GridTableCell :class="{ 'text-body-3': row.bold }" class="text-right">{{ row.col2 }}</GridTableCell>
        <GridTableCell :class="{ 'text-body-3': row.bold }" class="text-right">{{ row.col3 }}</GridTableCell>
        <GridTableCell :class="{ 'text-body-3': row.bold }" class="text-right">{{ row.col4 }}</GridTableCell>
      </template>
    </GridTable>
  </Grid>
</template>

<script>
// Components
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

const labelsKeysMap = [
  { label: 'Accepted renewals', key: 'accepted_renewals' },
  { label: 'Accepted new offers', key: 'accepted_new_offers' },
  { label: 'Current spend', key: 'current_spend', bold: true },
  { label: 'Pending Renewals w/prices', key: 'pending_renewals' },
  { label: 'Pending Renewals w/forecasted prices', key: 'pending_forecasted_renewals' },
  { label: `Pending Renewals using last year's prices`, key: 'pending_unpriced_renewals_using_last_years_price' },
  { label: 'Total Expected Spend', key: 'total_expected_spend', bold: true },
  { label: 'Pending New Offers', key: 'pending_new_offers' },
  { label: 'Total Expected Spend incl. New Offers', key: 'total_expected_spend_including_new_offers', bold: true },
  { label: 'Budget (all departments)', key: 'budget' },
  { label: 'Budget vs. Current spend', key: 'budget_vs_current_spend' },
  { label: 'Budget vs. Total expected spend', key: 'budget_vs_total_expected_spend' },
  {
    label: 'Budget vs. Total expected spend inc new offers',
    key: 'budget_vs_total_expected_spend_including_new_offers'
  }
]

export default {
  components: {
    GridTable,
    GridTableCell
  },

  props: {
    data: Object
  },

  computed: {
    columns() {
      const firstYear = this.data?.first_year_column.year
      const secondYear = this.data?.second_year_column.year
      const thirdYear = this.data?.third_year_column.year

      return [
        { label: 'Renewals & offers', width: '1fr' },
        { label: firstYear || 'Loading', width: '145px', align: 'right' },
        { label: secondYear || 'Loading', width: '145px', align: 'right' },
        { label: thirdYear || 'Loading', width: '145px', align: 'right' }
      ]
    },

    rows() {
      if (!this.data) return null

      return labelsKeysMap.reduce((acc, curr) => {
        acc.push({
          col1: curr.label,
          col2: this.formatPrice(this.data.first_year_column[curr.key]),
          col3: this.formatPrice(this.data.second_year_column[curr.key]),
          col4: this.formatPrice(this.data.third_year_column[curr.key]),
          bold: !!curr.bold
        })

        return acc
      }, [])
    }
  }
}
</script>
